import { render, staticRenderFns } from "./SalesForceTable.vue?vue&type=template&id=48554d6d&"
import script from "./SalesForceTable.vue?vue&type=script&lang=js&"
export * from "./SalesForceTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesForceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTable,QInput,QIcon,QBtn,QMenu,QList,QSeparator,QItem,QItemSection,QCardSection,QAvatar,QPopupProxy,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable,QInput,QIcon,QBtn,QMenu,QList,QSeparator,QItem,QItemSection,QCardSection,QAvatar,QPopupProxy})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
